{
  "open": "Sohbeti aç",
  "unread_one": "{count} okunmamış mesaj",
  "unread_other": "{count} okunmamış mesaj",
  "close": "Kapat"
}
